import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const ToothPain = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 33 35"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="evenodd">
      <path d="M23.76 13.93c-.044-2.29-1.125-4.003-2.626-4.988-1.496-.997-3.336-1.362-5.09-1.365-1.476.002-2.896.26-4.058.712-1.163-.454-2.584-.71-4.06-.713-1.754.003-3.594.368-5.09 1.365-1.5.985-2.583 2.7-2.626 4.987v.008c-.003.14-.004.284-.006.432-.02 2.812.814 4.33 1.523 5.56.688 1.25 1.27 2.23 1.29 4.893.003 3.615.59 5.918 1.458 7.402.854 1.474 2.07 2.112 3.09 2.112h.02c.286 0 .554-.045.805-.136.383-.138.673-.434.836-.722.168-.292.253-.59.315-.895.12-.61.14-1.29.16-2.04.03-1.493.05-3.256.5-4.75.19-.64.423-1.32.73-1.775.313-.443.572-.65 1.055-.706.484.055.74.263 1.055.706.306.455.54 1.135.728 1.776.6 1.97.425 4.363.563 6.072.058.58.126 1.1.414 1.612.163.29.453.584.842.724.243.088.512.135.8.135 1.025.008 2.25-.63 3.11-2.112.867-1.484 1.452-3.787 1.456-7.402.02-2.663.602-3.644 1.29-4.892.708-1.228 1.545-2.748 1.524-5.56 0-.147-.003-.294-.006-.44zm-3.09 5.113c-.72 1.25-1.544 2.834-1.525 5.78.004 3.42-.575 5.425-1.207 6.486-.64 1.064-1.245 1.213-1.553 1.22-.038 0-.073-.002-.102-.007-.023-.055-.057-.156-.08-.292-.08-.377-.11-1-.126-1.73-.04-1.47-.03-3.388-.578-5.225-.204-.667-.456-1.5-.955-2.258-.48-.752-1.343-1.456-2.504-1.514l-.055-.003-.054.003c-1.16.058-2.024.762-2.503 1.514-.5.757-.752 1.59-.955 2.258-.716 2.413-.492 5.007-.634 6.454-.03.39-.104.682-.15.794-.03.004-.064.007-.103.007-.306-.006-.914-.156-1.553-1.22-.63-1.063-1.21-3.066-1.206-6.486.02-2.945-.805-4.532-1.523-5.78-.698-1.264-1.27-2.166-1.29-4.674 0-.12.002-.252.004-.393.064-1.776.762-2.8 1.826-3.533.812-.55 1.878-.876 3-1l1.895-.026c1.1.085 2.135.336 2.876.673l.372.17.37-.168c.925-.42 2.297-.71 3.688-.708 1.5-.003 3.016.335 4.085 1.06 1.064.734 1.76 1.756 1.824 3.534.005.138.007.27.007.392-.02 2.508-.592 3.41-1.29 4.673z" />
      <path d="M16.525 6.113s9.76-.388 8.607 10.435l7.352-1.583-4.643-2.117 3.127-4.207-5.205-.837.628-5.618-4.62 2.427-1.758-4.09-3.487 5.59z" />
    </g>
  </svg>
);
ToothPain.defaultProps = {
  color: colors.blue,
};

ToothPain.propTypes = {
  color: PropTypes.string,
};

export default ToothPain;
